export default __webpack_public_path__ + "static/media/language-en.c1d571da.svg";